import { render, staticRenderFns } from "./languageEntryEdit.vue?vue&type=template&id=10bc5250&"
import script from "./languageEntryEdit.vue?vue&type=script&lang=js&"
export * from "./languageEntryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports